import React, { useState, useRef, useEffect, useContext } from 'react';
import { getAuth } from 'firebase/auth';
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { AppContext } from './AppContext';
import { Timestamp, getFirestore, doc, query, where, limit, getDocs, getDoc, setDoc, updateDoc, onSnapshot, serverTimestamp, addDoc, collection } from 'firebase/firestore';
import { firestore } from './firebase';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { ProfileComponentMyProfile } from './ProfileComponentMyProfile';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-modal';
import { FaCamera, FaArrowCircleRight, FaMusic, FaPlayCircle, FaPauseCircle, FaTimesCircle } from 'react-icons/fa';



const PostScreen = ({ onNavigate, onPost, onLive }) => {
  const [text, setText] = useState('');
  const [uploading, setUploading] = useState(false);

  const [tempImageUri, setTempImageUri] = useState(null);
const { livestreamingVisible, setMyPosts, setAllPosts, userId2, setLivestreamingVisible, showMediaPopup, currentUser, posts, setPosts, setJustPosted, startLivestream, assetsSummary } = useContext(AppContext);

  const [uploadProgress, setUploadProgress] = useState(0);
  const [mediaUri, setMediaUri] = useState(null);
  const [mediaType, setMediaType] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [comment, setComment] = useState("");
  const [searchResultsComments, setSearchResultsComments] = useState([]);
  const [isSearchingComments, setIsSearchingComments] = useState(false);
  const [tags, setTags] = useState([]);
  const commentInputRef = useRef(null);
  const [selection, setSelection] = useState({ start: 0, end: 0 });
  const navigate = useNavigate();

  const [posting, setPosting] = useState(false);




// Song snippet state (parity with RN)
const [songSnippet, setSongSnippet] = useState(null);

// DAT picker modal + selection
const [datModalVisible, setDatModalVisible] = useState(false);
const [selectedDat, setSelectedDat] = useState(null);

// Audio preview state for DAT picker
const [playingId, setPlayingId] = useState(null);
const previewAudioRef = useRef(null);

const canPost = text.trim().length > 0 || !!mediaUri || !!songSnippet;

  const MAX_VIDEO_DURATION_MS = 60_000;


  const openDatModal = () => {
  setDatModalVisible(true);
};


const getItemPreviewURL = (item) => {
  return (
    item?.previewURL ||
    item?.PreviewURL ||
    item?.SongURL ||
    item?.songURL ||
    item?.__parentAlbum?.previewURL ||
    item?.__parentAlbum?.PreviewURL ||
    item?.__parentAlbum?.SongURL ||
    item?.__parentAlbum?.songURL ||
    ''
  );
};


const stopAndUnloadPreview = async () => {
  try {
    if (previewAudioRef.current) {
      previewAudioRef.current.pause();
      previewAudioRef.current.src = '';
    }
  } catch (_) {}
  previewAudioRef.current = null;
  setPlayingId(null);
};

const closeDatModal = async () => {
  await stopAndUnloadPreview();
  setDatModalVisible(false);
  setSelectedDat(null);
};


const playPreviewFor = async (id, url) => {
  if (!url) {
    alert('No preview available for this item.');
    return;
  }
  try {
    if (previewAudioRef.current) {
      previewAudioRef.current.pause();
      previewAudioRef.current.src = '';
      previewAudioRef.current = null;
    }
  } catch (_) {}

  setPlayingId(id);

  const audio = new Audio(url);
  previewAudioRef.current = audio;

  audio.onended = () => {
    setPlayingId(null);
    previewAudioRef.current = null;
  };
  audio.onerror = () => {
    setPlayingId(null);
    previewAudioRef.current = null;
  };
  audio.play().catch(() => {
    setPlayingId(null);
    previewAudioRef.current = null;
  });
};

const handleTogglePlay = async (item, id) => {
  if (playingId === id && previewAudioRef.current) {
    // toggle pause/play
    if (previewAudioRef.current.paused) {
      setPlayingId(id);
      previewAudioRef.current.play().catch(() => {});
    } else {
      previewAudioRef.current.pause();
      setPlayingId(null);
    }
    return;
  }
  await playPreviewFor(id, getItemPreviewURL(item));
};


useEffect(() => {
  return () => {
    // cleanup preview audio on unmount
    try {
      if (previewAudioRef.current) {
        previewAudioRef.current.pause();
        previewAudioRef.current.src = '';
      }
    } catch (_) {}
    previewAudioRef.current = null;
  };
}, []);


  const navigateLivestream = async () => {
    await startLivestream(); // Ensure this completes first
    setLivestreamingVisible(true);
  };
  


  useEffect(() => {
    const searchUsers = async (queryText) => {
      const lastAtPos = queryText.lastIndexOf("@");
      if (lastAtPos === -1) {
        setIsSearchingComments(false);
        setSearchResultsComments([]);
        return;
      }
  
      const searchQuery = queryText.substring(lastAtPos + 1);
      if (searchQuery.length > 0) {
        setIsSearchingComments(true);
        const searchValue = searchQuery.toLowerCase();
        const usersRef = collection(firestore, 'users');
        const q = query(
          usersRef, 
          where('username_lower', '>=', searchValue),
          where('username_lower', '<=', searchValue + '\uf8ff'),
          limit(3)
        );
  
        try {
          const querySnapshot = await getDocs(q);
          const users = querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          }));
          setSearchResultsComments(users);
        } catch (error) {
          console.error("Error searching users:", error);
          setSearchResultsComments([]);
        }
      } else {
        setIsSearchingComments(false);
        setSearchResultsComments([]);
      }
    };
  
    if (text.includes("@")) {
      const delayDebounce = setTimeout(() => {
        searchUsers(text);
      }, 300);
  
      return () => clearTimeout(delayDebounce);
    }
  }, [text]);

  const handleSelectUser = (user) => {
    const cursorPosition = selection.start;
    const lastAtPos = text.lastIndexOf("@", cursorPosition);

    const beforeAt = text.substring(0, lastAtPos);
    const afterAt = text.substring(cursorPosition);

    const newComment = `${beforeAt}@${user.username} ${afterAt}`;
    setText(newComment);

    const newTag = {
      username: user.username,
      userId: user.id,
      start: beforeAt.length + 1,
      end: beforeAt.length + 1 + user.username.length
    };

    const updatedTags = [...tags.filter(tag => tag.end <= lastAtPos), newTag].sort((a, b) => a.start - b.start);
    setTags(updatedTags);

    setIsSearchingComments(false);
    setSearchResultsComments([]);

    const newCursorPos = beforeAt.length + user.username.length + 2;
    setSelection({ start: newCursorPos, end: newCursorPos });
  };

  const handleTextChange = (text) => {
    if (currentUser.username === "spndatnews" || text.length <= 1000) {
      setText(text);
    } else {
      setText(text.substring(0, 1000));
    }
  
    if (text.lastIndexOf("@") > (tags.length > 0 ? Math.max(...tags.map(tag => tag.end)) : -1)) {
      setIsSearchingComments(true);
    } else {
      setIsSearchingComments(false);
    }
  
    const adjustedTags = tags.map(tag => {
      if (text.substring(tag.start, tag.end) === `@${tag.username}`) {
        return tag; 
      } else {
        const startPos = text.indexOf(`@${tag.username}`);
        if (startPos !== -1) {
          return { ...tag, start: startPos, end: startPos + tag.username.length + 1 };
        }
      }
      return null; 
    }).filter(tag => tag !== null);
  
    setTags(adjustedTags);
  
  };

  const getCurrentUserId = () => {
    const auth = getAuth();
    const user = auth.currentUser;
    return user ? user.uid : null;
  };

  const [isPosting, setIsPosting] = useState(false);
  const [mediaDimensions, setMediaDimensions] = useState({ width: 0, height: 0 });

  const handlePost = async () => {
    if (isPosting) {
        return;
    }

    const auth = getAuth();
    const user = auth.currentUser;
  
    console.log("handlePost triggered");
  
    if (!user) {
        alert('Please log in to post');
        console.log("No user found. User must log in to post.");
        return;
    }
  
    if (!text && !mediaUri) {
        alert('Your post must contain text or media');
        console.log("Post aborted: No text or media provided.");
        return;
    }
  
    const postsCol = collection(getFirestore(), 'posts');
    const newPostRef = doc(postsCol);
    const postId = newPostRef.id;
  
    setIsPosting(true);
  
    console.log("Starting tag search...");
    
    // Search for @username patterns in the text
    const atPattern = /@(\w+)/g;
    let usernames = [...text.matchAll(atPattern)].map(match => match[1]);
  
    console.log("Found usernames in text:", usernames);
  
    // Create a new array to hold the tags
    let localTags = [];
    let updatedText = text;
  
    if (usernames.length > 0) {
        const usersRef = collection(firestore, 'users');
  
        for (const username of usernames) {
            console.log(`Searching for user: ${username}`);
            const q = query(usersRef, where('username_lower', '==', username.toLowerCase()), limit(1));
            const querySnapshot = await getDocs(q);
  
            if (!querySnapshot.empty) {
                const userDoc = querySnapshot.docs[0];
                const userData = userDoc.data();
  
                console.log(`User found: ${userData.username} (ID: ${userDoc.id})`);
  
                const startIdx = updatedText.indexOf(`@${username}`);
                const endIdx = startIdx + userData.username.length + 1; // +1 for '@'
  
                const newTag = {
                    username: userData.username,
                    userId: userDoc.id,
                    start: startIdx,
                    end: endIdx,
                };
                
                localTags.push(newTag);
                console.log(`Tag added: ${JSON.stringify(newTag)}`);
  
                // Update the text with the correct capitalization
                updatedText = 
                    updatedText.slice(0, startIdx) +
                    `@${userData.username}` +
                    updatedText.slice(startIdx + username.length + 1);
            } else {
                console.log(`No matching user found for: ${username}`);
            }
        }
    }
  
    console.log("Final tags to be used:", localTags);
    console.log("Updated text with correct capitalization:", updatedText);
  
    // Now we create the post data
    try {
        let downloadURL = null;
        if (mediaUri) {
          setUploading(true);
            downloadURL = await uploadMedia(mediaUri, (progress) => {
                setUploadProgress(progress);
                console.log(`Upload is ${progress}% done`);
            });
        }
  
        const userRef = userId2 ? doc(firestore, 'users', userId2) : null;
  
        console.log(
          '[handlePost] mediaDimensions:',
          'width=', mediaDimensions.width,
          'height=', mediaDimensions.height
        );
  
        const postData = {
          text,
          mediaType,
          postId,
          id: postId, 
          imageUri: downloadURL || '',
          imageWidth: mediaDimensions.width,
          imageHeight: mediaDimensions.height,
          accountType: currentUser.accountType,
          tags: localTags,
          songSnippet: songSnippet || null,
          createdAt: serverTimestamp(),
        };
  
        const now = Date.now();
  
        const newPostData = {
          ...postData,
          userId: user.uid,
          username: currentUser.username,
          name: currentUser.name,
          profileImageUrl: currentUser.profileImageUrl,
          userRef: userId2 ? doc(getFirestore(), 'users', userId2) : null,
          createdAt: now,
          likeCount: 0,
          repostCount: 0,
          likes: {},
          comments: [],
          repostUserIds: [],
        };
  
        console.log("New post data to be set in state:", newPostData);
  
        setAllPosts(prev => [ newPostData, ...prev ])
  
  // rather than [...prevPosts, newPostData]
  setPosts(prev => [ newPostData, ...prev ])
  
  // and for your personal feed
  setMyPosts(prev => [ newPostData, ...prev ])
  
      // Await the cloud function call
      const functions = getFunctions();
      const addPostTest = httpsCallable(functions, 'addPostVersion2');
  
      const response = await addPostTest(postData);
  
      // Optionally, update local posts state with response.data if needed.
      // For example, if your response returns the new post with a real postId and createdAt timestamp,
      // you might do:
      // setPosts(prevPosts => [response.data, ...prevPosts]);
  
      // Otherwise, if your app uses a realtime listener to update the posts list, you can simply navigate.
  
      // Clear form states
      setText('');
      setMediaUri(null);
      setMediaType(null);
      setTempImageUri(null);
      setUploading(false);
      setPosting(false); // Hide overlay
            setIsPosting(false);
            setSongSnippet(null);
setSelectedDat(null);
      navigate('/social');
    } catch (error) {
      console.error('Error creating post:', error);
      alert('Error creating post. Please try again later.');
      setUploading(false);
                  setIsPosting(false);
      setPosting(false);
    }
  };
  

  const uploadMedia = async (uri, onProgress) => {
    if (!uri) return null;
    const storage = getStorage();
    const userId = getCurrentUserId();
    const storageRef = ref(storage, `posts/${userId}/${Date.now()}`);
    
    const response = await fetch(uri);
    const blob = await response.blob();

    const metadata = {
      contentType: blob.type || 'image/png', // Use the correct MIME type
    };

    const uploadTask = uploadBytesResumable(storageRef, blob, metadata);

    return new Promise((resolve, reject) => {
      uploadTask.on('state_changed',
        (snapshot) => {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          onProgress(progress);
          
          switch (snapshot.state) {
            case 'paused':
              // Handle pause state if needed
              break;
            case 'running':
              // Handle running state if needed
              break;
          }
        },
        (error) => {
          console.error('Upload failed:', error);
          reject(error);
        },
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            resolve(downloadURL);
          }).catch((error) => {
            console.error('Error getting download URL:', error);
            reject(error);
          });
        }
      );
    });
  };

  const toggleModal = () => {
    setModalVisible(!modalVisible);
  };

  const navigateReleaseMusic = () => {
    navigate('/releaseMusic');   // route that shows the Release Music form
  };
  

  const handleMediaSelection = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const fileType = file.type;
    const MAX_VIDEO_DURATION_MS = 60_000; // 60 seconds

    // ---------- images ----------
    if (fileType.startsWith('image/')) {
      setMediaUri(URL.createObjectURL(file));
      setMediaType('image');
      return;
    }

    // ---------- videos ----------
    if (fileType.startsWith('video/')) {
      const tempUrl = URL.createObjectURL(file);
      const tempVideo = document.createElement('video');
      tempVideo.preload = 'metadata';
      tempVideo.src = tempUrl;

      tempVideo.onloadedmetadata = () => {
        const durationMs = tempVideo.duration * 1000;

        if (durationMs > MAX_VIDEO_DURATION_MS) {
          URL.revokeObjectURL(tempUrl);          // safe to revoke now
          alert("Please choose a video that's no longer than 60 seconds");
          event.target.value = null;             // reset file input
          return;
        }

        // keep tempUrl alive for the preview
        setMediaUri(tempUrl);
        setMediaType('video');
      };

      return;
    }

    alert('Please select an image or video file.');
  };




  const renderPostingOverlay = () => {
    if (!posting) return null;
    return (
      <div style={overlayStyles.container}>
        <div style={overlayStyles.message}>Posting...</div>
      </div>
    );
  };

  // Example overlay styling (adjust as needed)
  const overlayStyles = {
    container: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 10000,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    message: {
      color: 'white',
      fontSize: '24px',
      fontWeight: 'bold',
    },
  };

  const postContainerStyle = {
    padding: '10px',
    backgroundColor: 'rgba(0,0,0,0.5)',
    borderRadius: '8px',
    border: '1px solid rgba(23, 195, 250, 0.5)',
    margin: '0 10px',
    marginTop: '35px',
    maxHeight: 'auto', // Allow the container to adjust its height
    overflow: 'hidden', // Handle any potential overflow
  };

  return (
    <div style={styles.scrollContainer}>
      <div style={styles.container}>
        <div style={styles.commentSectionContainer}>
          {isSearchingComments && (
            <div style={styles.userSuggestionContainer}>
              {searchResultsComments.map((user) => (
                <div
                  key={user.id}
                  onClick={() => handleSelectUser(user)}
                  style={styles.userSuggestion}
                >
                  {user.username}
                </div>
              ))}
            </div>
          )}

          <div style={postContainerStyle}>
            <ProfileComponentMyProfile mediaUri={mediaUri} />

<div style={styles.addCommentContainer}>
  <textarea
    ref={commentInputRef}
    placeholder="What's happening?"
    value={text}
    onChange={(e) => handleTextChange(e.target.value)}
    onSelect={(e) =>
      setSelection({
        start: e.target.selectionStart,
        end: e.target.selectionEnd,
      })
    }
    style={styles.textInput}
    maxLength={1000}
  />
<div style={styles.composerFooterRow}>
  <div style={styles.footerLeft}>
    <label htmlFor="fileInput" style={styles.mediaIconButton} aria-label="Add media">
      <FaCamera size={18} color="#FFFFFF" />
    </label>
    <input
      id="fileInput"
      type="file"
      accept="image/*,video/*"
      onChange={handleMediaSelection}
      style={styles.fileInput}
    />

    <button
      type="button"
      onClick={openDatModal}
      aria-label="Add DAT snippet"
      style={{ ...styles.mediaIconButton, marginLeft: '8px' }}
      title="Add DAT snippet"
    >
      <FaMusic size={18} color="#FFFFFF" />
    </button>
  </div>
  <div style={styles.characterCount}>{text.length}/1000</div>
</div>


</div>


            {mediaUri && (
              <div onClick={toggleModal} style={styles.previewContainer}>
                {mediaType === 'video' ? (
                  <video
                    src={mediaUri}
                    style={styles.mediaPreview}
                    controls
                    alt="Video Preview"
                  />
                ) : (
                  <img
                    src={mediaUri}
                    style={styles.mediaPreview}
                    alt="Image Preview"
                  />
                )}
              </div>
            )}

{songSnippet && (
  <div style={styles.songPreviewRow}>
    <img
      src={songSnippet.artworkUrl || ''}
      alt="Artwork"
      style={styles.songPreviewThumb}
    />
    <div style={styles.songPreviewTextWrap}>
      <div style={styles.songPreviewTitle} title={songSnippet.name || 'Untitled'}>
        {songSnippet.name || 'Untitled'}
      </div>
      <div style={styles.songPreviewArtist} title={songSnippet.artist || 'Unknown Artist'}>
        {songSnippet.artist || 'Unknown Artist'}
      </div>
    </div>
    <button
      type="button"
      onClick={() => setSongSnippet(null)}
      aria-label="Remove selected song"
      style={styles.songPreviewRemoveBtn}
      title="Remove"
    >
      <FaTimesCircle size={22} />
    </button>
  </div>
)}


          </div>
        </div>

<div style={styles.postActionsRow}>
  {currentUser?.accountType !== 'Fan' && (
    <button style={styles.pillButton} onClick={navigateReleaseMusic}>
      RELEASE MUSIC
    </button>
  )}

  {currentUser?.accountType !== 'Fan' && (
    <button style={styles.pillButton} onClick={navigateLivestream}>
      LIVE
    </button>
  )}

<button
  style={{ ...styles.postArrowFab, ...(canPost ? {} : styles.postArrowFabDisabled) }}
  onClick={handlePost}
  disabled={uploading || !canPost}
  aria-label="Post"
  title="Post"
>
  <FaArrowCircleRight size={28} />
</button>

</div>


<Modal
  isOpen={datModalVisible}
  onRequestClose={closeDatModal}
  style={{
    overlay: { backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 1000000 },
    content: {
      background: 'rgba(12,12,20,0.98)',
      border: '1px solid rgba(255,255,255,0.12)',
      borderRadius: '16px',
      padding: '16px',
      maxWidth: '720px',
      maxHeight: '90vh',
      margin: 'auto',
      color: 'white',
    }
  }}
>
  <div style={styles.datModalTitle}>Choose Song</div>

  <div style={styles.datList}>
    {(Array.isArray(assetsSummary) ? assetsSummary : []).flatMap((a) => {
      const albumName = a?.AlbumName || a?.albumName || a?.title;
      const isTargetPractice = typeof albumName === 'string' && albumName.trim().toUpperCase() === 'TARGET PRACTICE EP';
      if (isTargetPractice && a?.songs) {
        const songsArray = Array.isArray(a.songs) ? a.songs : Object.values(a.songs || {});
        const picks = [songsArray[0], songsArray[2]].filter(Boolean);
        return picks.map((song, idx) => ({
          ...song,
          __kind: 'song',
          __parentAlbum: a,
          id: song?.id || song?.contentId || `TP-${idx}-${Math.random().toString(36).slice(2)}`
        }));
      }
      return [a];
    }).map((item) => {
      const isSong = item?.__kind === 'song';
      const id =
        item?.id ||
        item?.contentId ||
        `${(item?.SongName || item?.songName || item?.title || item?.VideoName || 'Untitled')}-${Math.random().toString(36).slice(2)}`;

      const title = isSong
        ? (item?.title || item?.SongName || item?.songName || item?.name || 'Untitled')
        : (item?.SongName || item?.songName || item?.title || item?.VideoName || 'Untitled');

      const artist = isSong
        ? (item?.artist || item?.ArtistName || item?.__parentAlbum?.ArtistName || item?.__parentAlbum?.artistName || 'Unknown Artist')
        : (item?.ArtistName || item?.artistName || item?.name || 'Unknown Artist');

      const artworkUrl =
        item?.ArtworkURL ||
        item?.artworkUrl ||
        item?.artworkURL ||
        item?.__parentAlbum?.ArtworkURL ||
        item?.__parentAlbum?.artworkUrl ||
        item?.__parentAlbum?.artworkURL ||
        '';

      const selected =
        !!selectedDat &&
        (selectedDat.id === item?.id || selectedDat.contentId === item?.contentId);

      return (
        <div
          key={id}
          onClick={() => setSelectedDat(item)}
          style={{ ...styles.datRow, ...(selected ? styles.datRowSelected : {}) }}
        >
          <div style={styles.datRowLeft}>
            <img src={artworkUrl} alt="art" style={styles.datThumb} />
            <div style={styles.datRowText}>
              <div style={styles.datTitle} title={title}>{title}</div>
              <div style={styles.datArtist} title={artist}>{artist}</div>
            </div>
          </div>

          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); handleTogglePlay(item, id); }}
            style={styles.datPlayBtn}
            aria-label={playingId === id ? 'Pause' : 'Play'}
            title={playingId === id ? 'Pause' : 'Play'}
          >
            {playingId === id ? <FaPauseCircle size={28} /> : <FaPlayCircle size={28} />}
          </button>
        </div>
      );
    })}
  </div>

  <div style={styles.datModalActions}>
    <button type="button" onClick={closeDatModal} style={styles.datCancelBtn}>Cancel</button>
    <button
      type="button"
      disabled={!selectedDat}
      onClick={async () => {
        if (!selectedDat) return;

        await stopAndUnloadPreview();

        const snippet = {
          name:
            selectedDat?.SongName ||
            selectedDat?.songName ||
            selectedDat?.title ||
            'Untitled',
          artist:
            selectedDat?.ArtistName ||
            selectedDat?.artistName ||
            selectedDat?.__parentAlbum?.ArtistName ||
            selectedDat?.__parentAlbum?.artistName ||
            'Unknown Artist',
          artworkUrl:
            selectedDat?.ArtworkURL ||
            selectedDat?.artworkUrl ||
            selectedDat?.artworkURL ||
            selectedDat?.__parentAlbum?.ArtworkURL ||
            selectedDat?.__parentAlbum?.artworkUrl ||
            selectedDat?.__parentAlbum?.artworkURL ||
            '',
          previewURL:
            selectedDat?.previewURL ||
            selectedDat?.PreviewURL ||
            selectedDat?.SongURL ||
            selectedDat?.songURL ||
            '',
          contentId:
            selectedDat?.contentId ||
            selectedDat?.id ||
            selectedDat?.__parentAlbum?.contentId ||
            '',
          userId:
            selectedDat?.userId ||
            selectedDat?.creatorId ||
            '',
        };

        setSongSnippet(snippet);
        closeDatModal();
      }}
      style={{ ...styles.datConfirmBtn, ...(selectedDat ? {} : styles.datConfirmBtnDisabled) }}
    >
      Confirm
    </button>
  </div>
</Modal>



        {modalVisible && (
          <div style={styles.modal}>
            <div style={styles.fullScreenContainer} onClick={toggleModal}>
              {mediaType === 'video' ? (
                <video
                  src={mediaUri}
                  style={styles.fullScreenMedia}
                  controls
                  autoPlay
                  loop
                  alt="Full Screen Video Preview"
                />
              ) : (
                <img
                  src={mediaUri}
                  style={styles.fullScreenMedia}
                  alt="Full Screen Image Preview"
                />
              )}
            </div>
          </div>
        )}

        {uploading && (
          <div style={styles.progressBarContainer}>
            <div
              style={{ ...styles.progressBar, width: `${uploadProgress}%` }}
            />
          </div>
        )}
              {renderPostingOverlay()}
      </div>
          <Modal
        isOpen={isPosting}
        style={{
          overlay: {
            backgroundColor: 'rgba(17, 14, 14, 0.75)',
            zIndex: 1000000
          },
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            border: 'none',
            background: 'transparent',
            color: 'white',
            borderRadius: '10px',
            padding: '20px',
            textAlign: 'center',
            zIndex: 1000000,
          }
        }}
      >
        <h2>Posting...</h2>
      </Modal>
    </div>
  );
};

const styles = {
  scrollContainer: {
    height: '100vh', // Full viewport height
    paddingBottom: '500px',
    overflowY: 'scroll', // Enable vertical scrolling
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start', // Align items at the top
    paddingTop: '70px',
    paddingBottom: '20px', // Optional: Add some padding at the bottom
    // Remove overflow from here
  },
  
  commentSectionContainer: {
    width: '100%',
    marginBottom: '2rem',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  userSuggestionContainer: {
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    padding: '5px 10px',
    borderRadius: '5px',
    marginTop: '10px',
  },
  userSuggestion: {
    color: '#FFFFFF',
    padding: '10px',
    fontSize: '1.6rem',
    borderWidth: '1px',
    borderColor: '#CCCCCC',
    borderStyle: 'solid',
    borderRadius: '5px',
    margin: '2px 0',
    cursor: 'pointer',
  },
  addCommentContainer: {
    display: 'flex',
    flexDirection: 'column',
alignItems: 'stretch',

    width: '100%',
  },
  textInput: {
    backgroundColor: 'transparent',
    padding: '20px 20px',
    width: '420px',
    fontSize: '16px',
    color: 'white',
    border: 'none',
    resize: 'none',
    marginBottom: '10px',
    textAlign: 'left',
    alignSelf: 'center',
    borderRadius: '20px',
    outline: 'none', // Removes default browser outline on focus
  },

  buttonsRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center', // Center the buttons horizontally
    alignItems: 'center',     // Align items vertically at the center
    width: '100%',
    marginTop: '-20px', // Add margin instead of positioning
  },
  
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column', // Stack the button and text vertically
    alignItems: 'center',
    margin: '0 10px',
    marginTop: '24px',
  },
  fileInputContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    alignSelf: 'center',
  },
  fileInput: {
    display: 'none',
  },
  customFileInputButton: {
    padding: '10px 20px',

    color: '#62fbfa',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    border: 'none',
    fontSize: '20px',
    marginBottom: '5px',
  },
  limitText: {
    color: 'white',
    fontSize: '13.5px',
    textAlign: 'center',
  },
  button: {
    padding: '10px 10px',
    color: '#62fbfa',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    border: 'none',
    fontSize: '20px',
    marginBottom: '5px',
  },
  previewContainer: {
    cursor: 'pointer',
    marginBottom: '10px',
    textAlign: 'center',
    width: '100%', // Ensure it takes full width of the container
  },
  mediaPreview: {
    maxWidth: '100%', // Ensure the media doesn't exceed the container's width
    maxHeight: '200px', // Set a reasonable max height
    width: 'auto',
    height: 'auto',
    marginBottom: '10px',
    borderRadius: '10px',
    objectFit: 'contain',
  },
  
  progressBarContainer: {
    width: '80%',
    backgroundColor: '#ccc',
    marginTop: '10px',
    height: '10px',
    alignSelf: 'center',
  },
  progressBar: {
    height: '100%',
    backgroundColor: '#6200EE',
  },
  fullScreenContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 1000,
  },
  fullScreenMedia: {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
  },
  modal: {
    display: 'block',
  },

  actionRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    width: '92%',
    padding: '12px 0',
    marginTop: '-30px',
  },
  
actionButton: {
  flex: 1,
  margin: '0 8px',
  padding: '12px 16px',
  borderRadius: '22px',
  backgroundColor: 'rgba(0,0,0,0.25)',
  color: 'white',
  fontSize: '15px',
  fontWeight: 700,
  letterSpacing: '0.3px',
  textAlign: 'center',
  border: '1px solid rgba(255,255,255,0.18)',
  cursor: 'pointer'
},

  
  actionText: {
    color: 'white',
    fontSize: '15px',
    fontWeight: '700',
    letterSpacing: '0.7px',
    textAlign: 'center',
  },
  
  releaseMusicButton: {
    width: '80%',
    alignSelf: 'center',
    marginTop: '22px',
    borderRadius: '34px',
    padding: '14px 0',
    backgroundColor: '#211043',
    color: 'white',
    fontSize: '18px',
    fontWeight: '700',
    letterSpacing: '1px',
    textAlign: 'center',
    border: 'none',
    cursor: 'pointer',
  },

  composerFooterRow: {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0 16px 8px 16px'
},

mediaIconButton: {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '44px',
  height: '44px',
  borderRadius: '22px',
  backgroundColor: 'rgba(0,0,0,0.35)',
  border: '1px solid rgba(255,255,255,0.18)',
  cursor: 'pointer'
},

postActionsRow: {
  display: 'flex',
  alignItems: 'center',
  width: '92%',
  padding: '12px 0',
  marginTop: '-30px'
},

pillButton: {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '12px 16px',
  borderRadius: '22px',
  backgroundColor: 'rgba(0,0,0,0.25)',
  color: 'white',
  fontSize: '15px',
  fontWeight: 700,
  letterSpacing: '0.3px',
  border: '1px solid rgba(255,255,255,0.18)',
  cursor: 'pointer',
  marginRight: '10px'
},

postArrowFab: {
  marginLeft: 'auto',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '56px',
  height: '56px',
  borderRadius: '28px',
  backgroundColor: 'rgba(0,0,0,0.35)',
  border: '1px solid rgba(255,255,255,0.18)',
  color: '#17C3FA',
  cursor: 'pointer'
},

postArrowFabDisabled: {
  opacity: 0.6
},
characterCount: {
  color: 'white',
  fontSize: '10px',
  opacity: 0.85,
},



composerFooterRow: {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  padding: '0 16px 8px 16px'
},
footerLeft: {
  display: 'flex',
  alignItems: 'center',
  gap: '8px'
},
mediaIconButton: {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '44px',
  height: '44px',
  borderRadius: '22px',
  backgroundColor: 'rgba(0,0,0,0.35)',
  border: '1px solid rgba(255,255,255,0.18)',
  cursor: 'pointer'
},
postArrowFab: {
  marginLeft: 'auto',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '56px',
  height: '56px',
  borderRadius: '28px',
  backgroundColor: 'rgba(0,0,0,0.35)',
  border: '1px solid rgba(255,255,255,0.18)',
  color: '#17C3FA',
  cursor: 'pointer'
},
postArrowFabDisabled: {
  opacity: 0.35,
  cursor: 'default'
},

songPreviewRow: {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '12px 8px',
  borderRadius: '12px',
  border: '1px solid rgba(255,255,255,0.12)',
  backgroundColor: 'rgba(0,0,0,0.25)',
  marginTop: '8px',
},
songPreviewThumb: {
  width: '56px',
  height: '56px',
  borderRadius: '8px',
  backgroundColor: 'rgba(255,255,255,0.08)',
  border: '1px solid rgba(255,255,255,0.12)',
  objectFit: 'cover',
},
songPreviewTextWrap: {
  flex: 1,
  padding: '0 12px',
  minWidth: 0,
},
songPreviewTitle: {
  color: '#FFFFFF',
  fontSize: '16px',
  fontWeight: 700,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
},
songPreviewArtist: {
  color: 'rgba(255,255,255,0.8)',
  fontSize: '14px',
  marginTop: '2px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
},
songPreviewRemoveBtn: {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'transparent',
  border: 'none',
  color: '#FFFFFF',
  cursor: 'pointer',
  padding: '4px',
},

datModalTitle: {
  color: '#FFFFFF',
  fontSize: '20px',
  fontWeight: 700,
  textAlign: 'center',
  marginBottom: '12px',
},
datList: {
  overflowY: 'auto',
  maxHeight: '65vh',
  paddingBottom: '8px',
},
datRow: {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '12px 10px',
  borderRadius: '12px',
  border: '1px solid rgba(255,255,255,0.12)',
  backgroundColor: 'rgba(0,0,0,0.25)',
  marginBottom: '8px',
  cursor: 'pointer',
},
datRowSelected: {
  border: '1px solid #17C3FA',
  backgroundColor: 'rgba(23,195,250,0.12)',
},
datRowLeft: {
  display: 'flex',
  alignItems: 'center',
  flex: 1,
  paddingRight: '10px',
  gap: '10px',
},
datThumb: {
  width: '56px',
  height: '56px',
  borderRadius: '8px',
  backgroundColor: 'rgba(255,255,255,0.08)',
  border: '1px solid rgba(255,255,255,0.12)',
  objectFit: 'cover',
},
datRowText: {
  flex: 1,
  minWidth: 0,
},
datTitle: {
  color: '#FFFFFF',
  fontSize: '16px',
  fontWeight: 700,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
},
datArtist: {
  color: 'rgba(255,255,255,0.8)',
  fontSize: '14px',
  marginTop: '2px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
},
datPlayBtn: {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'transparent',
  border: 'none',
  color: '#FFFFFF',
  cursor: 'pointer',
  padding: '4px',
},
datModalActions: {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: '8px',
  marginTop: '10px',
},
datCancelBtn: {
  padding: '10px 16px',
  borderRadius: '12px',
  backgroundColor: 'rgba(0,0,0,0.3)',
  border: '1px solid rgba(255,255,255,0.18)',
  color: '#FFFFFF',
  cursor: 'pointer',
},
datConfirmBtn: {
  padding: '10px 18px',
  borderRadius: '12px',
  backgroundColor: '#17C3FA',
  border: 'none',
  color: '#0B0B0F',
  fontWeight: 800,
  cursor: 'pointer',
},
datConfirmBtnDisabled: {
  backgroundColor: 'rgba(255,255,255,0.25)',
  cursor: 'not-allowed',
},



  
};

export default PostScreen;
